import {
  Link,
  useLocation,
  useMatch,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import Carousel from "react-bootstrap/Carousel";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import PaginationLayout from "../components/PaginationLayout";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import placeholder from "../assets/images/profile_placeholder.png"
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
export default () => {
  const [Reply, setReply] = useState(false);
  const handleCloseReply = () => setReply(false);
  //modal for Views
  const [Views, setViews] = useState(false);
  const handleCloseViews = () => setViews(false);

  const location = useLocation();
  const match = useMatch("/stories/:page");
  const navigate = useNavigate();
  const param = useParams();
  let limit = 9;
  const { authState, staticDataState, handleError, scrollToTop ,handlePagination, handleFilter} =
    useContext(GlobalContext);
  henceforthApi.setToken(authState.access_token);
  const [SoriesData, setStoriesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const newParam = new URLSearchParams(location.search);
  const fetchStories = async () => {
    try {
      let q = query.toString();
      setLoading(true)
      const StoriesRes = await henceforthApi.Stories.pagination(
        q,
        Number(param.page) - 1,
        limit
      );
      // console.log("StoriesRes", StoriesRes)
      setTotalCount(StoriesRes.count);
      setStoriesData(StoriesRes.stories);
    } catch (error) {
      setLoading(false)
      handleError(error)
    }
    finally {
      setLoading(false)
    }
  };
  const [manageMedias, setManageMedias] = useState({
    type: "",
    _id: "",
    admin_verified: false,
    language: "ENGLISH",
    account_status: "",
  });
  // const handleActivate = async (id, status) => {
  //   console.log("status", status);
  //   let data = {
  //     post_id: id,
  //     language: "ENGLISH",
  //     type: status == "Active" ? `DEACTIVE` : `ACTIVE`,
  //   };
  //   try {
  //     const manage_users = await henceforthApi.Common.activateDeactivate(data);
  //     console.log("Manage users", manage_users);
  //     setManageMedias(data);
  //     {
  //       status == "Active"
  //         ? Swal.fire({
  //           title: "Deactivated",
  //           text: "Account Deactivated Successfully",
  //           icon: "success",
  //           confirmButtonText: "OK",
  //           confirmButtonColor: "black"

  //         })
  //         : Swal.fire({
  //           title: "Activated",
  //           text: "Account Activated Successfully",
  //           icon: "success",
  //           confirmButtonText: "OK",
  //           confirmButtonColor: "black"

  //         });
  //     }
  //   } catch (error) {
  //     console.log(error, "error is ");
  //   }
  // }
  const [photoIndex, setPhotoIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const [lightboxImages, setLightboxImages] = useState([])
  const initialiseLightBox = (data) => {
    setPhotoIndex(0)
    setIsOpen(true)
    setLightboxImages(data)
  }

  //Filter
  var query = new URLSearchParams(location.search);
  const filters = [
    { name: "Live", value: "Live" },
    { name: "Expired", value: "Expired" },
    { name: "Activated", value: "Activated" },
    { name: "Deactivated", value: "Deactivated" }
  ];
  const onFilterApply = (name, value) => {
    if (query.has(name)) {
      let queryValue = query.get(name);
      // if (queryValue == value) {
      if (value === "") {
        query.delete(name);
      } else {
        query.set(name, value);
      }
    } else {
      query.set(name, value);
    }
    navigate({ pathname: `/stories/1`, search: query.toString() }, { replace: true });
  };

  //Remove
  const [showRemove, setShowRemove] = useState(false);
  // const handleConfirm = (id) => {
  //   console.log(id);
  //   setShowRemove(id);
  // }
  const handleRemove = async (id) => {
    console.log(id)
    try {
      await henceforthApi.Stories.delete(id);
      setShowRemove(false);
      fetchStories();
    } catch (Error) {
      // console.log("Error while removing posts", Error);
    }
    setShowRemove(false)
  };
  //View

  const [getView, setGetView] = useState([]);
  const handleView = async (_id) => {
    setViews(true);
    const viewResponse = await henceforthApi.Stories.view(_id);
    setGetView(viewResponse);
  };
  // console.log("viewRespons", getView);

  //Replies
  const [getReply, setGetReply] = useState([]);
  const handleReply = async (_id) => {
    setReply(true);
    const ReplyResponse = await henceforthApi.Stories.reply(_id);
    setGetReply(ReplyResponse);
  };
  // console.log("ReplyResponse", getReply);
  useEffect(() => {
    scrollToTop();
    fetchStories();
  }, [param.page, query.get("filter"), manageMedias]);

  return (
    <>
      <div class="row animated fadeInRight">
        <div class="col-md-12">
          <div>
            {isOpen && <Lightbox
              mainSrc={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${lightboxImages[photoIndex].media_url}`}
              nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
              prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % lightboxImages.length)
              }
            />}
          </div>
          <div className="ibox">
            <div className="ibox-title d-flex align-items-center justify-content-between">
                <h5 style={{ fontSize: "16px" }} className="m-0 fw-bold">
                List of all stories
              </h5>
              <div className="dropdown theme me-3">
                <button
                  className="btn dashboard-button pe-4 ps-4 dropdown-toggle shadow-none"
                  id="sortDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {filters.filter((res) => res.value == query.get("filter"))
                    .length
                    ? filters.filter(
                      (res) => res.value === query.get("filter")
                    )[0].name
                    : "All"}

                </button>
                <ul
                  className="dropdown-menu share-icons"
                  aria-labelledby="sortDropdown"
                >
                  {query.has("filter") && (
                    <li className="cursor-pointer">
                      <a
                        className="dropdown-item"
                        onClick={() => handleFilter("filter", "")}
                      >
                        All
                      </a>
                    </li>
                  )}
                  {filters.map((res) => {
                    return (
                      <li key={res.value} className="cursor-pointer">
                        <a
                          className="dropdown-item"
                          onClick={() => handleFilter("filter", res.value)}
                        >
                          {res.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="ibox-content">

              <div>
                {" "}
                <div className="row">
                  {!loading && !SoriesData?.length ? <div className="text-center"> <b> No Stories Found </b> </div> : SoriesData?.map((item, index) => (
                    <div class="col-md-6 col-lg-4 mb-4" key={item?.id}> 
                      <div class="card mb-4 box-shadow border-0 shadow h-100">
                        <Link to="">
                          <div className="explore-img">
                            <Carousel interval={null}>
                              {item?.post_medias?.length ?
                                item?.post_medias.map((res, index) => (
                                  <Carousel.Item key={index}>
                                    {(res?.media_type == "VIDEO" || res?.media_type == "VIDEO/MP4") ? (
                                      <video
                                        id="videos"
                                        class="video-bg"
                                        src={`https://shadowzapp.sgp1.digitaloceanspaces.com/shadowzapp/video/${res.media_url}`}
                                        autoPlay
                                        muted

                                      />
                                    ) : (
                                      <img
                                        className="d-block w-100"
                                        src={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${res?.media_url}`}
                                        alt=""
                                        onClick={() => initialiseLightBox(item?.post_medias)}
                                        style={{ cursor: "pointer" }}
                                      />
                                    )
                                    }
                                  </Carousel.Item>
                                )) : <img
                                  className="d-block w-100"
                                  src={placeholder}
                                  alt=""
                                  style={{ cursor: "pointer" }}
                                />}
                            </Carousel>
                          </div>
                        </Link>
                        <div class="card-body">
                          {/* <h2 className="fw-bolder" >{name}</h2> */}

                          <div className="username-box my-1 d-flex justify-content-between align-items-center">
                            <div className="d-flex gap-1 ProfileImagePRS-box">
                              <img className="ProfileImagePRS" src={
                                item?.profile_pic
                                  ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${item?.profile_pic}`
                                  : profile_placeholder
                              } alt="" />
                              <Link
                                to={`/user/${item?.user_id}/3/1?type=stories`}
                                className="Details_of_User"
                              >
                                <p className="fw-bolder m-0" style={{ fontSize: "14px", whiteSpace: 'nowrap' }}>
                                  {item?.name}
                                </p>
                              </Link >
                            </div>
                            <div>
                              <label className="PublicPrivate">
                                <i
                                  class={item?.is_private == false ?
                                    `fas fa-globe-africa` : `fas fa-lock`}
                                  style={{ marginRight: "3px" }}
                                ></i>
                                {item?.is_private == false
                                  ? "Public"
                                  : "Private"}
                              </label>
                            </div>
                          </div>
                          <div className="row">
                    <div className="col-12">
                    <div className="text-end">
                        <label className={item.status == "Active" ? "custom-status" : "custom-status-deactivate"}>
                          {item.status}
                        </label>
                      </div>
                    </div>
                
                  </div>

                          <div className="both-added my-3">
                            <div className="">
                              <div className="fw-bolder">
                                <h6
                                  onClick={() => handleView(item._id)}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "14px",
                                  }}
                                >
                                  {" "}
                                  Views:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      marginLeft: "3px",
                                    }}
                                  >
                                    {item.views_count}
                                  </span>
                                </h6>
                              </div>
                            </div>
                            <div className="brown-text text-wrap">
                              <div
                                onClick={() => handleReply(item._id)}
                                style={{ cursor: "pointer" }}
                                className="fw-bolder"
                              >
                                <h6 style={{ fontSize: "14px" }}>
                                  {" "}
                                  Replies:
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "14px ",
                                      marginLeft: "3px",
                                    }}
                                  >
                                    {item.replies_count}
                                  </span>
                                </h6>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div className="row align-items-center">
                            <div className="col-6">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="btn-group">
                                  <div className="bown-num">
                                    <p className="m-0">
                                      {" "}
                                      <small style={{ whiteSpace: "" }}>
                                        {moment(Number(item.created_at)).format(
                                          "DD MMM YYYY, h:mm a"
                                        )}
                                      </small>{" "}
                                    </p>
                                  </div>{" "}
                                  <div className="bown-num"></div>

                                </div>
                              </div>
                            </div>

                            {/* {item.is_expired == true ? (
                              " "
                            ) : ( */}
                            <div className="col-6">
                              <div className="text-end">
                                <Link to={`/media/${item._id}/view`}>
                                  <div className="">
                                    <button
                                      style={{ float: "right" }}
                                      className="btn mt-2 btn-outline-dark"
                                    >
                                      Details
                                    </button>
                                  </div>
                                  {/* activate  */}
                                </Link>
                              </div>
                              {/* <div>
                                <button
                                  onClick={() => handleActivate(item?._id, item?.status)}
                                  style={{ float: "right" }}
                                  className="btn btn-danger"
                                >
                                  {item?.status == "Active" ? "Active" : "Deactive"}
                                </button>
                              </div> */}
                            </div>
                            {/* )} */}
                            {/* Remove modal */}
                            <Modal
                              show={showRemove}
                              onHide={() => setShowRemove(false)}
                              backdrop="static"
                              keyboard={false}
                              centered
                              scrollable
                              className="confirm-box-modal"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Remove
                                </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="my-3 text-center">
                                  Do you want to Remove?
                                </div>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button onClick={() => setShowRemove(false)} className="px-6 confirm-btn">
                                  No
                                </Button>
                                <Button onClick={() => handleRemove(showRemove)} className="px-6 confirm-btn">
                                  Yes
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div>
                    <Modal
                      show={Views}
                      onHide={handleCloseViews}
                      centered
                      scrollable
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          <Link
                            to=""
                            style={{
                              textDecoration: "none",
                              color: "#000000",
                              cursor: "auto",
                            }}
                          >
                            Views on story
                          </Link>
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {getView?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Views</div> : getView?.views?.map((item, index) => (
                          <>
                            <div
                              class="tab-pane fade show active "
                              id="home"
                              role="tabpanel"
                              aria-labelledby="home-tab"
                            >
                              <div
                                className="modal-wrapper d-flex align-items-center  mx-2"
                                key={index}
                              >
                                <img
                                  src={
                                    item?.profile_pic
                                      ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${item?.profile_pic}`
                                      : profile_placeholder
                                  }
                                  alt="ProfileImage"
                                  class="modal-profile me-2"
                                />
                                <Link
                                  to={`/user/${item?.user_id}/1/1?type=posts`}
                                  className="Details_of_User"
                                >
                                  <p className="mb-0 profile-name">
                                    {item?.full_name
                                      ? item?.full_name
                                      : "No Views"}
                                  </p>
                                </Link>
                              </div>
                            </div>
                            <hr />
                          </>
                        ))}
                      </Modal.Body>
                    </Modal>

                    {/* Modal for Reply */}
                    <Modal
                      show={Reply}
                      onHide={handleCloseReply}
                      centered
                      scrollable
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          <Link
                            to=""
                            style={{
                              textDecoration: "none",
                              color: "#000000",
                              cursor: "auto",
                            }}
                          >
                            Replies on story
                          </Link>
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {getReply?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Replies</div> : getReply?.replies?.map((item, index) => (
                          <>
                            <div className="image-name-box d-flex gap-2 align-items-start w-100" key={index}>
                              <div className="image-box">
                                <img
                                  src={
                                    item?.profile_pic
                                      ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${item?.profile_pic}`
                                      : profile_placeholder
                                  }
                                  alt="ProfileImage"
                                  class="modal-profile align-items-start"
                                />
                              </div>

                              <div className="name-box w-100">
                                <div className="d-flex align-items-center justify-content-between align-items-center">
                                  <div>
                                    <Link
                                      to={`/user/${item?.user_id}/1/1?type=posts`}
                                      className="Details_of_User"
                                    >
                                      <p className="mb-0 profile-name">{item.full_name}</p>
                                    </Link>
                                  </div>
                                  <div className="">
                                    <p
                                      className="m-0"
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {moment(Number(item.created_at)).format("DD MMM YYYY, h:mm a")}
                                    </p>
                                  </div>
                                </div>
                                <p
                                  className="m-0"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                >
                                  {item.message}
                                </p>
                              </div>
                            </div>
                            <hr />
                          </>
                        ))}
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
              <PaginationLayout
                count={totalCount}
                data={SoriesData}
                page={Number(param.page)}
                limit={Number(limit)}
                loading={loading}
                onPageChange={(val) => handlePagination(val)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
